import { toast } from "react-toastify";
import {
  fetchCreateItemRequest,
  fetchCreateItemSuccess,
  fetchCreateItemFailure,
} from "./reducer";
import { CREATE_ITEM } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const createItem =
  (jsonObj, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchCreateItemRequest());

    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        CREATE_ITEM,
        "POST",
        jsonObj
      );

      if (response?.error) {
        dispatch(fetchCreateItemFailure(response.error.message));

        toast.error(response.error.message);
      } else {
        dispatch(fetchCreateItemSuccess(response));

        dispatch(setSuccessMessage(true));

        toast.success("Product Created Successfully");

        onSuccess && onSuccess();
      }
    } catch (error) {
      dispatch(fetchCreateItemFailure("Something went wrong"));

      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };